<template>
    <div class="fhv-centent"  v-loading="loading">
        <h4 class="title-topic">DMZ Host</h4>
        <el-alert
            title="No  found internet wan! Please create a new internet wan."
            type="warning"
            show-icon
            :closable="false"
            v-if="isFoundWan">
        </el-alert>
        <el-form
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="small"
            :model="form" 
            ref="form"
            :disabled="$G_DEVICE_CFG.isReadOnly || isFoundWan"
            >
            <el-form-item label="Enable DMZ :">
                <el-switch v-model="dmzEnable" @change="setDMZEnbale"></el-switch>
            </el-form-item>
            <div v-if="dmzEnable">
                <el-form-item 
                :rules="[ { required: true, message: 'Please select a internet wan.', trigger: 'change' }]"
                prop="wanIndex"
                label="Interface Selection:" >
                    <el-select v-model="form.wanIndex" placeholder="Please create a new internet wan" style="width: 100%" >
                        <el-option v-for="item in wanNname" :key="item.wanIndex" :label="item.wanName" :value="item.wanIndex"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="DMZ Host :"
                 :rules="[ { required: true, message: 'Please select a DMZ Host.', trigger: 'change' }]"
                 prop="dmzAddr">
                <el-select v-model="form.dmzAddr" placeholder="Please select" style="width: 100%" >
                        <el-option v-for="item in deviceList" :key="item.Mac" :label="item.Name" :value="item.ip">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="DMZ Host IP Address :">
                    <el-input v-model="form.dmzAddr" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm">Add</el-button>
                </el-form-item>
            </div>
        </el-form>
        <div v-if="dmzEnable">
            <h4>DMZ Host Lists:</h4>
            <el-table :data="dmzLists" stripe style="width: 100%" border class="fhv-table">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="dmzAddr" label="DMZ Host IP Address" ></el-table-column>
                <el-table-column prop="wanName" label="Interface" ></el-table-column>
                <el-table-column label="Method" width="80">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="deleteData(scope.$index)"
                            type="text"
                            size="small">
                            Delete
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            deviceList:[],
            dmzEnable:false,
            form:{
                dmzAddr:'',
                wanIndex:''
            },
            isFoundWan:false,
            wanNname:[],
            isFoundWan:false,
            dmzLists:[]
        }
    },
    created(){
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/JSONAPI",{cmdType:"GET_WEB_DMZ"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.dmzEnable = response.data.dmzEnable    
                    this.wanNname = response.data.wanList
                    if(this.wanNname.length > 0) this.form.wanIndex = this.wanNname[0].wanIndex
                    this.deviceList = response.data.topo.MainBaseInfo
                    this.isFoundWan = this.wanNname.length === 0
                    this.dmzLists = response.data.dmzHostArr
                }
                else
                    this.$message.error(`GET data failed!Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        addData() {
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WEB_DMZ_ADD",
                wanIndex:this.form.wanIndex,
                dmzAddr:this.form.dmzAddr
            })
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    this.getData()
                    this.$message.success('ADD DMZ Success!')
                }
                else
                {
                    this.loading = false
                    this.$message.error(`ADD DMZ Failed! Error:${response.data.errMsg}`)
                }
                    
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('ADD DMZ Failed! Network connection error!')
            })
        },
        deleteData(index){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WEB_DMZ_DEL",
                dmzIndex:index + 1,
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.dmzLists.splice(index,1)
                    this.$message.success('Delete DMZ success!')
                }
                else
                    this.$message.error(`Delete DMZ failed! Error:${response.data.errMsg}`)
                    
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Delete DMZ failed! Network connection error!')
            })
        },
        setDMZEnbale(val){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WEB_DMZ_ENABLE",
                dmzEnable:val,
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('SET DMZ Enable success!')
                }
                else
                    this.$message.error(`SET DMZ Enable failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('SET DMZ Enable failed! Network connection error!')
            })
        },
        submitForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.addData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
    },
}
</script>






